import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Card as UiCard, Box } from '../../../ui'
import { monthPicker, currencyFormat } from '../../../helpers'
import moment from 'moment'
import { Flash } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'
import style from './style.m.less'

interface ICardProps {
    item: any
}

const Card: FC<ICardProps> = ({ item }) => {
    const { t } = useTranslation()

    const payTypePicker = (type: number): string => {
        switch (type) {
            case 1:
                return t('greenTools.payTypeCertificate')
            case 2:
                return t('greenTools.payTypeGreenContract')
            case 3:
                return t('greenTools.payTypeExternalTools')
            default:
                return ''
        }
    }

    const {
        type,
        number,
        total_volume,
        consumer_volume,
        ts_repayment,
        ts_delivery,
        consumer_name,
        generators_data,
        consumer_personal_account,
        consumer_subject_name,
        consumer_buyer_name,
    } = item

    const productionPeriod = `${monthPicker(moment(ts_delivery).month() + 1)}, ${moment(
        ts_delivery,
    ).year()}`
    const isContract = type === 2
    const isCertificate = type === 1

    return (
        <UiCard className={style.card}>
            <div className={style.header}>{t('greenTools.consumptionData')}</div>
            <div className={style.wrapper}>
                <Box direction="row">
                    <div className={style.leftPart}>{t('greenTools.toolTypeLabel')}</div>
                    <div>{payTypePicker(type)}</div>
                </Box>
                <Box direction="row">
                    <div className={style.leftPart}>{t('greenTools.toolNumberLabel')}</div>
                    <div>{number}</div>
                </Box>
                <Box direction="row">
                    <div className={style.leftPart}>
                        {isContract ? t('greenTools.dateOperation') : t('greenTools.dateRepayment')}
                    </div>
                    <div>{moment(ts_repayment).format('DD.MM.YYYY')}</div>
                </Box>
                <Box direction="row">
                    <div className={style.leftPart}>
                        {isContract
                            ? t('greenTools.periodSupply')
                            : t('greenTools.periodProduction')}
                    </div>
                    <div>{productionPeriod}</div>
                </Box>
                <Box direction="row">
                    <div className={style.leftPart}>
                        {isContract
                            ? t('greenTools.sumPeriod')
                            : isCertificate
                            ? t('greenTools.sumCertificate')
                            : t('greenTools.sumOtherGreenTools')}
                    </div>
                    <div>{`${currencyFormat(total_volume)} ${t('greenTools.kwh')}`}</div>
                </Box>
                {consumer_name && (
                    <Box direction="row">
                        <div className={style.leftPart}>{t('greenTools.consumerNameLabel')}</div>
                        <div>{consumer_name}</div>
                    </Box>
                )}
                {consumer_personal_account && (
                    <Box direction="row">
                        <div className={style.leftPart}>{t('greenTools.accountLabel')}</div>
                        <div>{consumer_personal_account}</div>
                    </Box>
                )}
                {consumer_subject_name && (
                    <Box direction="row">
                        <div className={style.leftPart}>{t('greenTools.subjectNameLabel')}</div>
                        <div>{consumer_subject_name}</div>
                    </Box>
                )}
                {consumer_buyer_name && (
                    <Box direction="row">
                        <div className={style.leftPart}>{t('greenTools.buyerNameLabel')}</div>
                        <div>{consumer_buyer_name}</div>
                    </Box>
                )}
                <Box direction="row">
                    <div className={style.leftPart}>{t('greenTools.volumeLabel')}</div>
                    <div>{`${currencyFormat(consumer_volume)} ${t('greenTools.kwh')}`}</div>
                </Box>
            </div>
            {generators_data
                ? generators_data.map((generator_data: any) => (
                      <Box margin="10px 0px" display="flex" key={generator_data.generator_id}>
                          <Link
                              to={`/generator-card/${generator_data.generator_id}`}
                              className={style.link}
                          >
                              <Box direction="row" align="center">
                                  <Flash />
                                  <Box margin="0px 5px">{generator_data.generator_name}</Box>
                              </Box>
                          </Link>
                      </Box>
                  ))
                : ''}
        </UiCard>
    )
}

export default Card
